/** One row per unique individual name (first match keeps id/title), for parachute per-person grids. */
export function getUniqueIndividualsFromForm(formData: {
  individuals?: { id: string; name: string; title?: string }[];
}) {
  const individuals = formData.individuals || [];
  const uniqueNames = Array.from(new Set(individuals.map((i: { name: string }) => i.name)));
  return uniqueNames.map((name) => individuals.find((i) => i.name === name));
}
